import ReactDOMServer from 'react-dom/server';
import styled from 'styled-components';
import { AppRemixIcon } from '@/layout/AppComponents';
import Translator from '../../../../components/helpers/Translator';

export default function BtnOptions(props) {
  const { isDisabled, handleOnSubmit, handleOnSave = null } = props;

  return (
    <Container save={handleOnSave}>
      {handleOnSave && (
        <span
          className={`btn btn-info ${isDisabled && 'disabled'} save-btn`}
          title={ReactDOMServer.renderToString(
            <Translator
              file="module-intelligence"
              name="module.int.save-profile"
            />
          )}
          onClick={() => !isDisabled && handleOnSave(true)}
        >
          <AppRemixIcon icon="save" />
        </span>
      )}
      <span
        className={`btn btn-info btn-block ${isDisabled &&
          'disabled'} generate-btn`}
        onClick={() => !isDisabled && handleOnSubmit()}
      >
        <Translator file="module-intelligence" name="module.int.btn.generate" />
      </span>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.save && '60px'} 1fr;
  .save-btn {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin-right: 1px;
  }
  .generate-btn {
    border-top-left-radius: ${(props) => (props.save ? 0 : '0.25rem')};
    border-bottom-left-radius: ${(props) => (props.save ? 0 : '0.25rem')};
  }
`;
